/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { scroller } from 'react-scroll';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import filesize from 'filesize';

import { ReactComponent as AlertIcon } from '../../../assets/icons/ubr_alert.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/ubr_arrow_down.svg';
import { ReactComponent as UpdateIcon } from '../../../assets/icons/ubr_update.svg';
import { ReactComponent as UploadIcon } from '../../../assets/icons/ubr_upload.svg';
import {
  Button,
  Divider,
  Layout,
  Modal,
  Pagination,
  Shimmer,
} from '../../../components';
import Accordion from '../../../components/Accordion';
import Upload from '../../../components/Upload';
import FileList from '../../../components/Upload/FileList';
import { useToast } from '../../../hooks/toast';
import { useAuth } from '../../../hooks/useAuth';
import api from '../../../services/api';
import { EndpointsAPI } from '../../../services/Endpoints';
import { DateFormAndTime } from '../../../utils/date';
import { hash } from '../../../utils/hashGenerator';
import {
  Badge,
  BadgeError,
  Container,
  FileWrapper,
  FooterContainer,
  FooterContainerModal,
  HeaderTable,
  ImportFileContainer,
  Label,
  List,
  LoadingData,
  TableContainer,
} from './styles';

interface FileProps {
  id: string;
  file: File;
  name: string;
  readableSize: string;
  uploaded?: boolean;
  progress?: number;
  error?: boolean;
}

interface DataProps {
  pageable: [
    {
      pageNumber: number;
      pageSize: number;
    },
  ];
  totalElements: number;
  totalPages: number;
}

interface MotorArquivoCobranca {
  idArquivoMotor: string;
  status: string;
  dataCriacao: string;
  motorEnum: string;
  nomeArquivoOriginal: string;
  identificadorArquivoRepositorio: string;
  nomeRepositorio: string;
}

function getPrimeiroMotorArquivo(
  valor: MotorArquivoCobranca[] | MotorArquivoCobranca | null | undefined,
): MotorArquivoCobranca | undefined {
  if (valor == null) {
    return undefined;
  }
  if (Array.isArray(valor)) {
    return valor[0];
  }
  return valor;
}

export const Motor: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  let [idPdf, setIdPdf] = useState<string>('');
  const [data, setData] = useState<DataProps | any>([]);
  const [uploadedCnab, setuploadedCnab] = useState<FileProps[] | any>([]);
  const [uploadedPdf, setUploadedPdf] = useState<FileProps[] | any>([]);
  const formRefCnab = useRef<FormHandles | null>(null);
  const formRefPdf = useRef<FormHandles | null>(null);
  const [showErrorFile, setShowErrorFile] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [showErrorPDFModal, setShowErrorPDFModal] = useState<boolean>(false);
  const [showErrorCNABxPDFModal, setShowErrorCNABxPDFModal] = useState<boolean>(
    false,
  );
  const [showModalPdf, setShowModalPdf] = useState<boolean>(false);
  const [pageSizeData, setPageSizeData] = useState<number>(5);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>();
  const { addToast } = useToast();

  const { user } = useAuth();

  const fetchData = useCallback(
    async (apiPage: number, apiPageSize: number) => {
      setIsLoading(true);

      const response = await api.get(
        `/processo-cobranca/${user.agencia}/${user.conta}?page=${apiPage}&size=${apiPageSize}`,
      );

      setData(response.data?.content ?? []);
      setTotalPages(response.data?.totalPages ?? 0);
      setIsLoading(false);
    },
    [],
  );

  const scrollTo = () => {
    scroller.scrollTo('tableData', {
      duration: 1000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -120,
    });
  };

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
      </tr>
    );
  };

  // Render Posts

  const [sort, setSort] = useState(false);

  const sortData = useCallback(() => {
    let order;

    if (sort) {
      order = [...data].sort((a, b) => {
        return a.leitorCnab.dataCriacao.localeCompare(b.leitorCnab.dataCriacao);
      });
    } else {
      order = [...data].sort((a, b) => {
        return b.leitorCnab.dataCriacao.localeCompare(a.leitorCnab.dataCriacao);
      });
    }
    setData(order);
  }, [sort]);

  const renderPost = () => {
    let tmpItem = 'DEFAULT' as any;
    return (
      <>
        <TableContainer>
          <HeaderTable>
            <Button
              variant={'solid-icon'}
              onClick={() => fetchData(0, pageSizeData)}
              tooltipText={'Atualizar tabela'}
            >
              <UpdateIcon
                width={28}
                className={!uploadedCnab.length && isLoading ? 'rotate' : ''}
              />
            </Button>
          </HeaderTable>
          <div>
            <table id="tableData">
              <thead>
                <tr>
                  <th style={{ width: '160px' }}>
                    <div onClick={() => setSort(!sort)}>
                      Data
                      <ArrowDown width={24} className={sort ? 'active' : ''} />
                    </div>
                  </th>
                  <th style={{ width: '250px' }}>Validação</th>
                  <th style={{ width: '150px' }}>PDF</th>
                  <th style={{ width: '200px' }}>Status</th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody>
                  {loadingTable()}
                  {loadingTable()}
                  {loadingTable()}
                </tbody>
              ) : !data ? (
                <LoadingData> Sem dados para exibir... </LoadingData>
              ) : (
                <tbody>
                  {data.map((todo: any, index: number) => {
                    const givenDate = new Date(
                      todo.leitorCnab !== null
                        ? todo.leitorCnab.dataCriacao
                        : '2021-05-03T14:13:36.193',
                    ) as any;

                    const date = new Date().getTime() - 43200000;
                    const currentDate = new Date(date).getTime();

                    return (
                      <tr key={index}>
                        <td data-heading="Data">
                          {todo.leitorCnab !== null
                            ? DateFormAndTime(todo.leitorCnab.dataCriacao)
                            : 'N/A'}
                        </td>

                        <td data-heading="Validação">
                          <div>
                            <Badge
                              type={
                                todo.motorCnab !== null
                                  ? todo.motorCnab.status
                                  : 'DEFAULT' && todo.leitorCnab !== null
                                  ? todo.leitorCnab.status
                                  : 'DEFAULT'
                              }
                              onClick={
                                todo.leitorCnab !== null
                                  ? todo.leitorCnab.status === 'ERRO'
                                    ? () =>
                                        showModalError(
                                          todo.leitorCnab.idArquivoMotor,
                                        )
                                    : (() => {}) ||
                                      todo.motorCnab.status === 'ERRO'
                                    ? () =>
                                        showModalError(
                                          todo.motorCnab.idArquivoMotor,
                                        )
                                    : () => {}
                                  : () => {}
                              }
                            >
                              CNAB
                            </Badge>
                            {todo.leitorPdf.length >= 1 && (
                              <>
                                {todo.leitorPdf.map((data: any) => {
                                  if (data.status === 'ERRO') {
                                    tmpItem = 'ERRO';
                                  } else if (data.status === 'SUCESSO') {
                                    tmpItem = 'SUCESSO';
                                  } else if (data.status === 'PENDENTE') {
                                    tmpItem = 'PENDENTE';
                                  } else if (data.status === 'PROCESSANDO') {
                                    tmpItem = 'PROCESSANDO';
                                  } else {
                                    tmpItem = 'DEFAULT';
                                  }

                                  return true;
                                })}
                              </>
                            )}
                            {todo.motorPdf.length >= 1 && (
                              <>
                                {todo.motorPdf.map((data: any) => {
                                  if (data.status === 'ERRO') {
                                    tmpItem = 'ERRO';
                                  } else if (data.status === 'SUCESSO') {
                                    tmpItem = 'SUCESSO';
                                  } else if (data.status === 'PENDENTE') {
                                    tmpItem = 'PENDENTE';
                                  } else if (data.status === 'PROCESSANDO') {
                                    tmpItem = 'PROCESSANDO';
                                  } else {
                                    tmpItem = 'DEFAULT';
                                  }

                                  return true;
                                })}
                              </>
                            )}

                            <Badge
                              type={
                                (todo.leitorPdf.length && tmpItem) ||
                                (todo.motorPdf.length && tmpItem)
                              }
                              onClick={() =>
                                todo.leitorPdf.length &&
                                todo.leitorPdf[0].status === 'ERRO'
                                  ? todo.leitorPdf.map((data: any) => {
                                      return showModalErrorPDF(
                                        data.idArquivoMotor,
                                      );
                                    })
                                  : todo.motorPdf.length &&
                                    todo.motorPdf[0].status === 'ERRO'
                                  ? todo.motorPdf.map((data: any) => {
                                      return showModalErrorPDF(
                                        data.idArquivoMotor,
                                      );
                                    })
                                  : () => {}
                              }
                            >
                              PDF
                            </Badge>

                            <Badge
                              type={
                                todo.leitorPdf !== '[]' ||
                                todo.motorPdf !== '[]' ||
                                todo.leitorPdf !== null ||
                                todo.motorPdf !== null ||
                                todo.leitorPdf !== undefined ||
                                todo.motorPdf !== undefined
                                  ? todo.motorCnabPdf
                                    ? (todo.leitorPdf.length &&
                                        todo.leitorPdf[0].status === 'ERRO') ||
                                      (todo.motorPdf.length &&
                                        todo.motorPdf[0].status === 'ERRO')
                                      ? 'DEFAULT'
                                      : todo.motorCnabPdf.status
                                    : 'DEFAULT'
                                  : 'DEFAULT'
                              }
                              onClick={
                                todo.leitorCnabPdf?.status === 'ERRO'
                                  ? () =>
                                      showModalErrorCNABxPDF(
                                        todo.leitorCnabPdf?.idArquivoMotor,
                                      )
                                  : (() => {}) ||
                                    todo.motorCnabPdf?.status === 'ERRO'
                                  ? () =>
                                      showModalErrorCNABxPDF(
                                        todo.motorCnabPdf?.idArquivoMotor,
                                      )
                                  : () => {}
                              }
                            >
                              CNAB x PDF
                            </Badge>
                          </div>
                        </td>
                        <td data-heading="PDF">
                          <div
                            style={{
                              alignItems: 'flex-start',
                              gap: '8px',
                            }}
                          >
                            <Button
                              variant="solid-icon"
                              tooltipText={'Upload de PDF'}
                              disabled={
                                todo.mensagemProcesso ===
                                `Arquivo CNAB validado. Favor enviar os boletos clicando no botão 'Envio de boleto/PDF'.`
                                  ? false
                                  : true || givenDate <= currentDate
                                  ? true
                                  : false
                              }
                              onClick={() =>
                                (showModal(todo.idProcesso) as any) &&
                                setIdPdf(todo.idProcesso)
                              }
                            >
                              <UploadIcon width={24} />
                            </Button>
                            <p style={{ marginTop: 12 }}>Envio de boleto/PDF</p>
                          </div>
                        </td>
                        <td data-heading="Status">
                          <BadgeError type={todo.status}>
                            {todo.status ? todo.status : 'AGUARDANDO'}
                          </BadgeError>
                          <p style={{ cursor: 'unset', fontSize: '14px' }}>
                            {todo.mensagemProcesso}
                          </p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </table>
          </div>
        </TableContainer>

        <div>
          <Pagination
            pageCount={totalPages!}
            marginPagesDisplayed={2}
            pageRangeDisplayed={pageSizeData}
            forcePage={currentPage - 1}
            onPageChange={(pageNumber: any) => {
              setCurrentPage(pageNumber.selected + 1);
              fetchData(pageNumber.selected, pageSizeData);
            }}
            onPageSize={(pageSize: any) => {
              setCurrentPage(1);
              setPageSizeData(pageSize.value);
              fetchData(0, pageSize.value);
            }}
          />
        </div>
      </>
    );
  };

  // File Upload Cnab

  const handleSubmitCnab = useCallback(async () => {
    setIsLoading(true);
    const { file } = uploadedCnab[0];

    const dataFile = new FormData();
    dataFile.append('file', file, file.name);
    dataFile.append('agencia', user.agencia);
    dataFile.append('conta', user.conta);
    dataFile.append('cooperativa', user.cooperativa);
    dataFile.append('produto', 'COBRANCA');

    const response = await api
      .post(`${EndpointsAPI.motorCobrancaCnab}`, dataFile, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: () => {
          return true;
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });

    try {
      if (response.status === 400) {
        addToast({
          type: 'error',
          title: `Erro ao enviar o CNAB`,
          description: `${response.data.details[0]}`,
          time: 6000,
        });
        fetchData(0, pageSizeData);
        removeFileCnab();
      } else {
        addToast({
          type: 'success',
          title: `Sucesso ao enviar o CNAB`,
          description: `Arquivo CNAB enviado para extração dos dados.`,
          time: 6000,
        });

        removeFileCnab();
        scrollTo();
        setTimeout(() => {
          fetchData(0, pageSizeData);
          setIsLoading(false);
        }, 1500);
      }
    } catch (err) {
      console.error(err);
    }
  }, [uploadedCnab]);

  function submitFileCnab(files: File[]): void {
    const fileUpload = files.map(file => ({
      file,
      name: file.name,
      readableSize: filesize(file.size),
      type: file.type,
    }));
    setuploadedCnab(fileUpload);
    setShowErrorFile(true);
  }

  const removeFileCnab = () => {
    setuploadedCnab('');
  };

  // File Upload PDF

  const showModal = (id: string) => {
    setShowModalPdf(true);
    removeFilePdfOnUpload();
    setIdPdf(id);
  };

  const handleSubmitPdf = async (uploadedPdf: FileProps) => {
    setIsLoading(true);

    const data = new FormData();

    if (uploadedPdf.file) {
      data.append('file', uploadedPdf.file, uploadedPdf.name);
      data.append('agencia', user.agencia);
      data.append('conta', user.conta);
      data.append('cooperativa', user.cooperativa);
      data.append('produto', 'COBRANCA');
    }

    const response = await api
      .post(`${EndpointsAPI.motorCobrancaPdf}/${idPdf}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        validateStatus: () => {
          return true;
        },
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });

    try {
      if (response.status !== 200) {
        addToast({
          type: 'error',
          title: `Erro ao enviar o PDF!`,
          description: `${response.data.details[0]}`,
        });
        setIsLoading(false);
      } else {
        addToast({
          type: 'success',
          title: `PDF enviado com sucesso!`,
          description: `O arquivo ${uploadedPdf.name} foi enviado para o servidor!`,
        });
        setShowModalPdf(false);
        fetchData(0, pageSizeData);
        removeFilePdfOnUpload();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const submitFilePdf = useCallback((files: File[]) => {
    const fileUpload: FileProps[] = files.map((file: File) => ({
      file,
      id: hash(filesize(file.size)),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false,
      error: false,
    }));

    setUploadedPdf(fileUpload);
    setShowErrorFile(true);
  }, []);

  const removeFilePdf = (id: string) => {
    setUploadedPdf(uploadedPdf.filter((file: any) => file.id !== id));
  };

  const removeFilePdfOnUpload = () => {
    setUploadedPdf('');
  };

  const fetchError = useCallback(async (id: string) => {
    const { data } = await api.get(
      EndpointsAPI.motorCobranca + `/${id}/criticas`,
    );

    if (data !== undefined) {
      setDataError(data);
    }
  }, []);

  const [idError, setIdError] = useState<string>();
  const [dataError, setDataError] = useState<any>([]);

  const showModalError = (id: string) => {
    setShowErrorModal(true);
    setIdError(id);
    fetchError(id);
  };

  const showModalErrorCNABxPDF = (id: string) => {
    setShowErrorCNABxPDFModal(true);
    setIdError(id);
    fetchError(id);
  };

  const showModalErrorPDF = (id: string) => {
    setShowErrorPDFModal(true);
    setIdError(id);
    fetchError(id);
  };

  const renderErroModal = () => {
    return (
      <Modal
        show={showErrorModal || showErrorPDFModal || showErrorCNABxPDFModal}
        titulo={
          showErrorModal
            ? 'Erro no arquivo CNAB enviado'
            : showErrorPDFModal
            ? 'Erro no(s) PDF(s) enviados'
            : showErrorCNABxPDFModal
            ? 'Erro ao comparar CNAB e PDF'
            : ''
        }
        mensagem={`Você deve verificar os erros, corrigi-los e tentar novamente.`}
        onCancel={() => {
          showErrorModal && setShowErrorModal(false);
          showErrorPDFModal && setShowErrorPDFModal(false);
          showErrorCNABxPDFModal && setShowErrorCNABxPDFModal(false);
          setDataError([]);
        }}
        onConfirm={() => {}}
      >
        {(dataError.length && showErrorModal) ||
        (dataError.length && showErrorPDFModal) ? (
          dataError.map((data: any, index: number) => {
            return (
              <List key={index}>
                <div className="list-content-secondary">
                  <span>
                    <b> ERRO ENCONTRADO: </b>
                  </span>
                  {data.mensagem}
                </div>

                {showErrorPDFModal && (
                  <li>
                    <b className="list-content-principal">DETALHES DE ERRO: </b>
                    <>Linha: {data.linha}</>
                  </li>
                )}

                <li>
                  {showErrorModal && (
                    <b className="list-content-principal">DETALHES DO ERRO: </b>
                  )}
                  {showErrorPDFModal && (
                    <b className="list-content-principal">POSIÇÕES: </b>
                  )}

                  <>
                    {showErrorModal && <>Linha: {data.posicaoLinha}</>} Posição
                    Inicial: {data.posicaoInicial}, Posição Final:{' '}
                    {data.posicaoFinal}
                  </>
                </li>
                {data.valorEsperado === null ||
                data.valorEsperado === undefined ||
                data.valorEsperado === '' ||
                data.valorEsperado === 'SEM VALOR ESPERADO' ? null : (
                  <li>
                    <b className="list-content-principal">VALOR ESPERADO: </b>
                    {data.valorEsperado}
                  </li>
                )}
                <li>
                  <b className="list-content-principal">VALOR INFORMADO: </b>
                  {data.valor}
                </li>
                <Accordion
                  id={hash(index)}
                  key={index}
                  title="Mais Informações"
                  description={
                    <>
                      <li>
                        <b>Campo: </b>
                        {data.chave}
                      </li>
                      <li>
                        <b>Tipo de segmento: </b>
                        {data.tipoValidacaoModelo}
                      </li>

                      <li>
                        <b>Tipo de validação: </b>
                        {data.validacaoCritica}
                      </li>
                    </>
                  }
                />
              </List>
            );
          })
        ) : dataError.length && showErrorCNABxPDFModal ? (
          dataError.map((data: any, index: number) => {
            return (
              <List key={index}>
                <div className="list-content-secondary">
                  <span>
                    <b> ERRO ENCONTRADO: </b>
                  </span>
                  {data.mensagem}
                </div>

                <li>
                  <b className="list-content-principal">DETALHES DE ERRO: </b>
                  <>
                    Linha: <b>{data.linha}</b>
                  </>
                </li>
                {data.valorEsperado === null ||
                data.valorEsperado === undefined ||
                data.valorEsperado === '' ||
                data.valorEsperado === 'SEM VALOR ESPERADO' ? null : (
                  <li>
                    <b className="list-content-principal">
                      VALOR ESPERADO DO CNAB:{' '}
                    </b>
                    {data.valorEsperado}
                  </li>
                )}
                <li>
                  <b className="list-content-principal">
                    VALOR INFORMADO DO PDF:{' '}
                  </b>
                  {data.valor}
                </li>
                <Accordion
                  id={hash(index)}
                  key={index}
                  title="Mais Informações"
                  description={
                    <>
                      <li>
                        <b>Campo: </b>
                        {data.chave}
                      </li>
                      <li>
                        <b>Tipo de segmento: </b>
                        {data.tipoValidacaoModelo}
                      </li>

                      <li>
                        <b>Tipo de validação: </b>
                        {data.validacaoCritica}
                      </li>
                    </>
                  }
                />
              </List>
            );
          })
        ) : (
          <>
            <div style={{ marginTop: '2rem' }}>
              <Shimmer height={'25px'} />
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ display: 'flex', marginTop: '0.5rem' }}>
                <Shimmer width={'60%'} height={'25px'} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Shimmer height={'25px'} />
              </div>
              <div style={{ marginTop: '1rem' }}>
                <Shimmer height={'25px'} />
              </div>
            </div>
          </>
        )}
      </Modal>
    );
  };
  useEffect(() => {
    fetchData(0, pageSizeData);
  }, []);

  useEffect(() => {
    sortData();
  }, [sort]);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return;
    }
    const processo = data[0];
    const leitorCnab = processo.leitorCnab;
    const motorCnab = processo.motorCnab;
    const leitorPdfPrimeiro = processo.leitorPdf?.[0];
    const motorPdfPrimeiro = processo.motorPdf?.[0];
    const motorCnabPdfPrimeiro = getPrimeiroMotorArquivo(processo.motorCnabPdf);
    if (leitorCnab?.status === 'ERRO') {
      setTimeout(() => {
        setShowErrorModal(leitorCnab.idArquivoMotor);
        fetchError(leitorCnab.idArquivoMotor);
      }, 300);
      return;
    }
    if (motorCnab?.status === 'ERRO') {
      setTimeout(() => {
        setShowErrorModal(motorCnab.idArquivoMotor);
        fetchError(motorCnab.idArquivoMotor);
      }, 300);
      return;
    }
    if (leitorPdfPrimeiro?.status === 'ERRO') {
      setTimeout(() => {
        showModalErrorPDF(leitorPdfPrimeiro.idArquivoMotor);
      });
      return;
    }
    if (motorPdfPrimeiro?.status === 'ERRO') {
      setTimeout(() => {
        showModalErrorPDF(motorPdfPrimeiro.idArquivoMotor);
      });
      return;
    }
    if (motorCnabPdfPrimeiro?.status === 'ERRO') {
      setTimeout(() => {
        showModalErrorPDF(motorCnabPdfPrimeiro.idArquivoMotor);
      });
    }
  }, [data]);

  // =========================================================================================

  return (
    <>
      {renderErroModal()}
      <Modal
        show={showModalPdf}
        titulo={'Upload de arquivos PDF'}
        mensagem={`Você deve enviar o(s) PDF(s) para completar a homologação.`}
        onCancel={() => setShowModalPdf(false)}
        onConfirm={() => {}}
      >
        <Form
          className="form-container"
          ref={formRefPdf}
          onSubmit={handleSubmitPdf}
        >
          <ImportFileContainer>
            <Label>Arquivos</Label>
            <FileWrapper>
              <>
                {!!uploadedPdf.length && (
                  <FileList files={uploadedPdf} handleErase={removeFilePdf} />
                )}
              </>
            </FileWrapper>
            <Upload
              multiple={true}
              onUpload={submitFilePdf}
              accept={'application/pdf'}
            />
            <div style={{ marginTop: '1rem', width: '100%' }}>
              <Button
                variant="solid"
                style={{ width: '100%' }}
                type="submit"
                disabled={!uploadedPdf.length}
                loading={uploadedPdf.length && isLoading}
                loadingMessage={'Enviando Arquivo...'}
                onClick={() => uploadedPdf.forEach(handleSubmitPdf)}
              >
                Enviar
              </Button>
            </div>
            <FooterContainerModal>
              <p>
                <AlertIcon />
                Limite máximo de 5mb
              </p>
            </FooterContainerModal>
          </ImportFileContainer>
        </Form>
      </Modal>
      <Layout title="Motor de Cobrança" titlePage={'Motor de cobrança'}>
        <Container>
          <Form
            className="form-container"
            ref={formRefCnab}
            onSubmit={handleSubmitCnab}
          >
            <ImportFileContainer>
              <Label>Arquivos</Label>
              <FileWrapper>
                {!!uploadedCnab.length && (
                  <FileList files={uploadedCnab} handleErase={removeFileCnab} />
                )}
              </FileWrapper>
              <Upload
                onUpload={submitFileCnab}
                accept={'text/*, .REM, .rem, .ret, .RET'}
              />
              <FooterContainer>
                <p>
                  <AlertIcon />
                  Limite máximo de 5mb
                </p>
                <div>
                  <Button
                    variant="solid"
                    style={{ marginTop: '1rem' }}
                    type="submit"
                    disabled={!uploadedCnab.length}
                    loading={uploadedCnab.length && isLoading}
                    loadingMessage={'Enviando Arquivo...'}
                  >
                    Adicionar
                  </Button>
                </div>
              </FooterContainer>
            </ImportFileContainer>
          </Form>
        </Container>
        <Divider marginAround={'2rem'} />
        <div>{data && renderPost()}</div>
        {data && data[0]?.status === 'ERRO' ? renderErroModal() : undefined}
      </Layout>
    </>
  );
};
